import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

export const Mail = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M3.42881 4.25128C3.2145 4.25128 3.04912 4.41667 3.04912 4.63097V11.369C3.04912 11.5833 3.2145 11.7487 3.42881 11.7487H12.5712C12.7772 11.7487 12.9425 11.5803 12.9363 11.3696C12.9361 11.3645 12.936 11.3593 12.936 11.3542V4.63097C12.936 4.41667 12.7707 4.25128 12.5563 4.25128H3.42881ZM1.99784 4.63097C1.99784 3.83606 2.6339 3.2 3.42881 3.2H12.5563C13.3513 3.2 13.9873 3.83606 13.9873 4.63097V11.3473C14.006 12.1421 13.3715 12.8 12.5712 12.8H3.42881C2.6339 12.8 1.99784 12.1639 1.99784 11.369V4.63097Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M2.07577 4.35557C2.22788 4.10831 2.55163 4.03117 2.7989 4.18328L8 7.38288L13.2011 4.18328C13.4484 4.03117 13.7721 4.10831 13.9242 4.35557C14.0763 4.60283 13.9992 4.92659 13.7519 5.0787L8.27542 8.44772C8.10651 8.55163 7.89349 8.55163 7.72458 8.44772L2.24806 5.0787C2.0008 4.92659 1.92366 4.60283 2.07577 4.35557Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);
